var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useReducer, useContext } from "react";
import InstitutionRegionContext from "./InstitutionRegionContext";
import "./Lightcast.scss";
import { sendRequest } from "../../common/http";
import { AppContext } from "../../contexts/AppContext";
import translate from "src/i18n/translate";
import { WmButton } from "@watermarkinsights/ripple-react";
import Trends from "./Trends";
import ChangeInPopulation from "./population/ChangeInPopulation";
import LaborForce from "./LaborForce";
import Industries from "./industries/Industries";
import Occupations from "./occupations/Occupations";
import LightcastFooter from "./LightcastFooter";
import { getLoaderStatus } from "../common/helper";
import { defaultLaborForceBreakdown, defaultRegionalContext } from "./Interface";
var defaultContextResult = {
    regionalContext: defaultRegionalContext,
    showLightcastWidget: false
};
var defaultLightcastAction = {
    type: "",
    contextResult: defaultContextResult,
    lfb: defaultLaborForceBreakdown,
    component: "",
    lfbApiError: false
};
var reducer = function (state, action) {
    switch (action.type) {
        case "setRegionalContext":
            return __assign(__assign({}, state), { regionalContext: action.contextResult.regionalContext, showLightcastWidget: action.contextResult.showLightcastWidget });
        case "setLaborForceBreakdown":
            return __assign(__assign({}, state), { laborForceBreakdown: action.lfb, laborForceBreakdownLoader: false });
        case "setApiError":
            return __assign(__assign({}, state), { lfbApiError: action.lfbApiError });
        case "setLoadedComponent":
            var component = action.component;
            var loadedComponents = state.loadedComponents;
            loadedComponents[component] = true;
            return __assign(__assign({}, state), { loadedComponents: loadedComponents });
        default:
            return state;
    }
};
var allComponentsLoaded = function (loadedComponents) {
    return (loadedComponents.regionalContext &&
        loadedComponents.populationByRace &&
        loadedComponents.populationByAge &&
        loadedComponents.occupations &&
        loadedComponents.industries &&
        loadedComponents.trendsAndLaborforce);
};
var initialState = {
    regionalContext: null,
    showLightcastWidget: false,
    laborForceBreakdown: null,
    loadedComponents: {
        regionalContext: false,
        populationByRace: false,
        populationByAge: false,
        occupations: false,
        industries: false,
        trendsAndLaborforce: false
    },
    laborForceBreakdownLoader: true,
    lfbApiError: false
};
export default function Lightcast(_a) {
    var setLightcastTab = _a.setLightcastTab;
    var _b = useContext(AppContext), setComponentLoaded = _b.setComponentLoaded, institution = _b.institution;
    var _c = useReducer(reducer, initialState), state = _c[0], dispatch = _c[1];
    var openPreviewModal = function () {
        setComponentLoaded("openPreviewModal");
    };
    var openlaborForceHtmlViewLink = function () {
        return window.open(getURL(), "_blank");
    };
    var getURL = function () {
        var queryString = window.location.search;
        var param = new URLSearchParams(queryString);
        var locale = param.get("locale");
        var url = "/insights/labor_market/html";
        if (locale !== null) {
            url = "".concat(url, "?locale=").concat(locale);
        }
        return url;
    };
    useEffect(function () {
        var applyResult = function (result) {
            if (result.showLightcastWidget)
                setLightcastTab();
            dispatch(__assign(__assign({}, defaultLightcastAction), { type: "setRegionalContext", contextResult: result }));
            onComponentLoad("regionalContext");
        };
        sendRequest({ uri: "/lightcast/regional_context", camelize: true }, applyResult);
    }, []);
    var setLaborForceBreakdown = function (lfb) {
        lfb &&
            dispatch(__assign(__assign({}, defaultLightcastAction), { type: "setLaborForceBreakdown", lfb: lfb }));
    };
    var setApiError = function (lfbApiError) {
        dispatch(__assign(__assign({}, defaultLightcastAction), { type: "setApiError", lfbApiError: lfbApiError }));
    };
    useEffect(function () {
        var liveRegion = document.querySelector(".lightcast-status");
        getLoaderStatus(!allComponentsLoaded(state.loadedComponents), liveRegion);
    }, [allComponentsLoaded(state.loadedComponents)]);
    var onComponentLoad = function (component) {
        dispatch(__assign(__assign({}, defaultLightcastAction), { type: "setLoadedComponent", component: component }));
    };
    return (_jsx("section", { className: (institution === null || institution === void 0 ? void 0 : institution.navigatedFrom) === "planning"
            ? "body lightcast-body"
            : "body tab-body-home", id: "lightcast-insights", children: _jsxs("section", { className: "insights", children: [_jsxs("div", { className: "institution-name lightcast-header", children: [_jsx("span", { className: "sr-only lightcast-status", role: "status", "aria-live": "assertive" }), _jsx("h3", { className: "helper-label helper-default-margin", children: translate("app.lightcast.regionLabel") }), _jsxs("div", { className: "helper-text", children: [translate("app.lightcast.helperDescription"), _jsx(WmButton, { id: "lightcast-learn-more", buttonType: "textonly", onClick: openPreviewModal, children: _jsx("span", { className: "read-more", children: translate("app.learnMore") }) })] }), _jsx("div", { className: "share-insights", children: _jsx(WmButton, { "button-type": "secondary", icon: "f3cc", "icon-size": "14px", onClick: function () { return openlaborForceHtmlViewLink(); }, children: translate("app.lightcast.shareInsights") }) })] }), state.showLightcastWidget ? (_jsxs(_Fragment, { children: [_jsx("div", { className: "wm-grid", children: _jsxs("div", { className: "wm-grid-row", children: [_jsx(InstitutionRegionContext, { regionalContext: state.regionalContext, onComponentLoad: onComponentLoad }), _jsx("div", { className: "grid-container wm-grid-col-12 wm-grid-col-lg-12 wm-grid-col-md-10 wm-grid-col-sm-8", children: _jsx(Trends, { setLaborForceBreakdown: setLaborForceBreakdown, onComponentLoad: onComponentLoad, setApiError: setApiError }) })] }) }), _jsx("div", { children: _jsx("div", { className: "grid-container change-in-population", children: _jsx(ChangeInPopulation, { onComponentLoad: onComponentLoad }) }) }), _jsx("div", { className: "wm-grid-row", children: _jsx("div", { className: "grid-container wm-grid-col-12 wm-grid-col-xl-12 wm-grid-col-lg-12 wm-grid-col-md-10 wm-grid-col-sm-8", children: _jsx(LaborForce, { laborForceBreakdown: state.laborForceBreakdown, laborForceBreakdownLoader: state.laborForceBreakdownLoader, lfbApiError: state.lfbApiError }) }) }), _jsx("div", { className: "wm-grid", children: _jsxs("div", { className: "wm-grid-row", children: [_jsx(Industries, { onComponentLoad: onComponentLoad }), _jsx(Occupations, { onComponentLoad: onComponentLoad }), _jsx(LightcastFooter, {})] }) })] })) : (_jsx("div", { className: "grid-container-empty wm-grid-col wm-grid-col-lg-6 wm-grid-col-md-10 -min-width" }))] }) }));
}
